module.exports = __webpack_public_path__ + "img/ayaka-nishi_banner.77010e4f.jpg";